export const solarPaymentNoticeClients = [
  {
    value: "solar_ark",
    label: "Ark",
  },
]

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const durationOptions = [
  {value: 20,label: 20,isFixed: true},
  {value: 25,label: 25,isFixed: true},
  {value: 30,label: 30,isFixed: true},
  {value: 35,label: 35,isFixed: true},
  {value: 40,label: 40,isFixed: true},
  {value: 45,label: 45,isFixed: true},
  {value: 50,label: 50,isFixed: true},
  {value:60,label: 60,isFixed: true}
]
